export default "__VITE_ASSET__BSit6ZFJ__"